import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { PartsPersonnelComponent } from './parts-personnel.component';
import { PartsPersonnelRoutingModule } from './parts-personnel-routing.module';

@NgModule({
  declarations: [PartsPersonnelComponent],
  imports: [
    CommonModule,
    SharedModule,
    PartsPersonnelRoutingModule,
    TranslateModule
  ],
  exports: [TranslateModule]
})
export class PartsPersonnelModule { }
